import React from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import landingImg from '../../Assets/images/PNG/Home/landingImg.png'
import Typography from '@mui/material/Typography'
import { Button, Container } from '@mui/material'
import './Header.css'


const header = () => {
  return (
    <Box id='/' sx={{ bgcolor: 'background.custom', height: '100vh',width:'100%',overFlow:'hidden' }} className="header">
      <Container >
        <Grid container spacing={0}  >
          <Grid item xs={12} sm={6}>
            <Box className='headerText'>
               <Typography variant="" color="#ffffff" fontWeight={600} className='header_heading'>We Make your Insurance Personal Forms <a href="#">Efficient <img src='arrowDown.svg'/></a></Typography>
              <Typography variant="h6" color="rgba(255,255,255,0.7)" sx={{ width: '88%', marginTop: '20px' }} className='header_text' >Certiform is a platform based solution for insurance agents and brokers that standardises and enhances the information collection and management processes.</Typography>
              <Box sx={{ marginTop: '30px' }} className='mobile_header_Button'>
                <Button variant="contained" color="primary" className="header_Button" >Try for free</Button>
                <Button variant="outlined" color="primary" className="header_Button" style={{marginLeft:'20px'}}>Watch a demo</Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} >
              <img src={landingImg} alt="" className='header_Img' style={{marginLeft:"auto"}}/>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default header